import React from 'react';
import { Helmet } from 'react-helmet-async';

export default function SEO({ title, description, lang }) {
  const siteTitle = lang === 'en' ? 'Beer Pass' : 'Pase Cervecero';
  const fullTitle = `${title} | ${siteTitle}`;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={description} />
      <html lang={lang} />
    </Helmet>
  );
}